import { render, staticRenderFns } from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=template&id=6d52adeb&lang=pug"
import script from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=script&lang=js"
export * from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./BlocoSkeletonInformacaoCertificacao.vue?vue&type=style&index=0&id=6d52adeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports